'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _CloudinaryImage = require('web-makeup/dist/CloudinaryImage');

var _CloudinaryImage2 = _interopRequireDefault(_CloudinaryImage);

var _PayPage = require('../PayPage');

var _InvoicePayment = require('../InvoicePayment/InvoicePayment.style');

var _CreditCardForm = require('../CreditCardForm/CreditCardForm');

var _CreditCardForm2 = _interopRequireDefault(_CreditCardForm);

var _PaymentLogo = require('../PaymentLogo/PaymentLogo');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var NewCardForm = function NewCardForm(_a) {
    var title = _a.title,
        paymentMethod = _a.paymentMethod,
        onPaymentMethodChanged = _a.onPaymentMethodChanged,
        saveCard = _a.saveCard,
        onSaveCardToogle = _a.onSaveCardToogle;
    return React.createElement("div", null, React.createElement(_InvoicePayment.AlignedContainer, null, React.createElement(_InvoicePayment.StyledRadio, { onChange: function onChange() {
            return onPaymentMethodChanged(_PayPage.PaymentMethod.NEW_CARD);
        }, checked: paymentMethod === _PayPage.PaymentMethod.NEW_CARD }, React.createElement(_InvoicePayment.Title, null, title)), React.createElement(_CloudinaryImage2.default, { useSourceFormat: true, source: {
            id: 'v1/-homepage-icons/-footer/badges-cards',
            type: 'upload'
        } })), paymentMethod === _PayPage.PaymentMethod.NEW_CARD && React.createElement(React.Fragment, null, React.createElement(_CreditCardForm2.default, { saveCard: saveCard, onSaveCardToogle: onSaveCardToogle }), React.createElement(_PaymentLogo.PaymentLogo, null)));
};
exports.default = NewCardForm;
//# sourceMappingURL=NewCardForm.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-ui/dist/order/views/pay-page/NewCardForm/NewCardForm.js
// module id = 1954
// module chunks = 0